import { useAuth } from "./auth/AuthProvider";
import { Spinner } from "@heroui/react";

const Chat = () => {
    const { userProfile, loadingProfile } = useAuth();

    if (loadingProfile) {
        return (
            <div
                sx={{
                    width: '100%',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Spinner size="lg" />
            </div>
        );
    }

    const authorizedEmails = [
        "darwin@rskgroupco.com",
        "caguilar@rskgroupco.com"
    ];

    const isAuthorized = authorizedEmails.includes(userProfile?.email);

    return (
        <div
            sx={{
                width: '80%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                margin: 'auto',
            }}
        >
            <p>Configurar chat con datos de entrenamiento</p>
            {isAuthorized ? (
                <MainChat userProfile={userProfile} />
            ) : (
                <p>You are not allowed to see this page.</p>
            )}
        </div>
    );
};

const MainChat = ({ userProfile }) => {
    return (
        <>
            <p>{userProfile?.first_name}</p>
            <p>{userProfile?.last_name}</p>
            <p>{userProfile?.email}</p>
        </>
    );
};

export default Chat;
